module.exports = __webpack_public_path__ + "static/media/tb-aking.06ad93a7.jpeg";